import React from "react";
import { Auth } from "aws-amplify";


const SSOLogin = (props) => {

  const submitButtonStyle = {
    borderRadius: "4px",
    height: "45px",
    borderWidth: "thin",
    backgroundColor: props?.color,
    border: "none",
    color: "white",
    cursor: 'pointer'
  };
 
  return (
    <div style={{ display: "grid", padding: "2em" }}>
      {/* <label style={{ fontSize: "x-large" }}>SSO Login</label> */}
      {/* <br /> */}
      <input
        type="submit"
        style={submitButtonStyle}
        onClick={() => Auth.federatedSignIn()}
        value={'Sign in with SSO'}
      />

    </div>
  );
};

export default SSOLogin;
